import { RootState } from '../index';

const getScheduleList = (state: RootState) => state.schedulesReducer.scheduleList;

const getSelectedShiftDate = (state: RootState) => state.schedulesReducer.selectedShiftDate;

const getSelectedScheduleShift = (state: RootState) => state.schedulesReducer.selectedScheduleShift;

const getIsOpenDeleteShiftDialog = (state: RootState) => state.schedulesReducer.isOpenDeleteShiftDialog;

const getIsOpenDayOffNav = (state: RootState) => state.schedulesReducer.isOpenDayOffNav;

const getIsDisplayPublishBtn = (state: RootState) => state.schedulesReducer.isDisplayPublishBtn;

const getTimeOffs = (state: RootState) => state.schedulesReducer.timeOffs;

const getIsOpenBulkDialog = (state: RootState) => state.schedulesReducer.isOpenBulkDialog;

const getIsOpenDeleteTimeOffDialog = (state: RootState) => state.schedulesReducer.isOpenDeleteTimeOffDialog;

const getSelectedShiftMember = (state: RootState) => state.schedulesReducer.selectedShiftMember;

const getSelectedLocationId = (state: RootState) => state.schedulesReducer.selectedLocationId;

const getSelectedStatus = (state: RootState) => state.schedulesReducer.selectedStatus;

const getIsOpenShiftNotesNav = (state: RootState) => state.schedulesReducer.isOpenShiftNotesNav;

const getIsOpenCopyShiftsNav = (state: RootState) => state.schedulesReducer.isOpenCopyShiftsNav;

export {
  getScheduleList,
  getSelectedShiftDate,
  getSelectedScheduleShift,
  getIsOpenDeleteShiftDialog,
  getIsOpenDayOffNav,
  getIsDisplayPublishBtn,
  getTimeOffs,
  getIsOpenBulkDialog,
  getIsOpenDeleteTimeOffDialog,
  getSelectedShiftMember,
  getSelectedLocationId,
  getSelectedStatus,
  getIsOpenShiftNotesNav,
  getIsOpenCopyShiftsNav,
};
